import { remify } from '@dynamic/ui';
import styled from 'styled-components';

import { tb } from '#/store/translation/translation.store';

import { Brand, usePaymentCardLogos } from './PaymentCardLogos.hook';

export const BRAND_INFO: Record<Brand, { imagePath: string; title: string }> = {
  VISA: { imagePath: 'images/card-visa.svg', title: 'Visa' },
  MASTERCARD: { imagePath: 'images/card-mastercard.svg', title: 'Mastercard' },
  AMEX: { imagePath: 'images/card-amex.svg', title: 'American Express' },
  DISCOVER: { imagePath: 'images/card-discover.svg', title: 'Discover' },
  JCB: { imagePath: 'images/card-jcb.svg', title: 'JCB' },
  DINERS: {
    imagePath: 'images/card-diners.svg',
    title: 'Diners Club International',
  },
  UNION_PAY: { imagePath: 'images/card-union-pay.svg', title: 'Union Pay' },
};

const LogoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${remify(8)};
  margin-bottom: ${remify(16)};
`;

const Logo = styled.img`
  width: ${remify(38)};
  height: ${remify(24)};
`;

export const PaymentCardLogos = () => {
  const { staticFilePrefix, brands, isEnabled } = usePaymentCardLogos();

  if (!isEnabled) {
    return null;
  }

  return (
    <LogoContainer
      aria-label={tb('tts.payment.acceptedCreditCards')}
      role="group"
    >
      {brands.map((brand) => {
        const { title, imagePath } = BRAND_INFO[brand];

        return (
          <Logo
            alt={title}
            key={brand}
            src={`${staticFilePrefix}${imagePath}`}
            title={title}
          />
        );
      })}
    </LogoContainer>
  );
};
